<style scoped>
  .selector{
    display: inline-block;
    width: 100%;
  }
  .selector /deep/ .ivu-poptip{
    width: 100%;
  }
  .selector /deep/ .ivu-poptip-rel{
    width: 100%;
  }
  .selector-btn{
    padding-left: 8px;
    text-align: left;
  }
</style>
<template>
  <div class="selector">
    <Poptip :tranfer="false">
      <Button class="selector-btn" long :disabled="disabled">
        <span>类型: {{getInvoiceType(income.invoice_type)}} </span>
        <span v-if="income.invoice_type >= 0">
          <span> - 税率: {{getTaxRate(income.tax_rate)}} </span>
          <span>
            <span> - 税额: </span>
            <span>{{formatPrice(income.tax)}}</span>
          </span>
        </span>
      </Button>
      <div slot="content">
        <div class="line">
          <span class="form-label">类型:</span>
          <Select size="small" @on-change="taxDataChange(income)" v-model="income.invoice_type" style="width: 80px">
            <Option :value="type.value" v-for="type in invoice_types" :key="type.value">{{type.name}}</Option>
          </Select>
        </div>
        <div v-if="income.invoice_type >= 0">
          <div class="line">
            <span class="form-label">税率:</span>
            <Select size="small" @on-change="taxDataChange(income)" v-model="income.tax_rate" style="width: 80px">
              <Option value="0.0">0%</Option>
              <Option value="0.01">1%</Option>
              <Option value="0.02">2%</Option>
              <Option value="0.03">3%</Option>
              <Option value="0.04">4%</Option>
              <Option value="0.05">5%</Option>
              <Option value="0.06">6%</Option>
              <Option value="0.07">7%</Option>
              <Option value="0.08">8%</Option>
              <Option value="0.09">9%</Option>
              <Option value="0.1">10%</Option>
              <Option value="0.13">13%</Option>
              <Option value="0.16">16%</Option>
            </Select>
          </div>
          <div class="line">
            <span class="form-label">税额:</span>
            <i-input size="small" v-model="income.tax" style="width: 80px"></i-input>
          </div>
        </div>
        <div class="hr"></div>
        <Button type="primary" long size="small" @click="closePoptip">确定</Button>
      </div>
    </Poptip>
  </div>
</template>
<script>
  import InvoiceUtil from '../../invoice/libs/util';
  export default {
    props: {
      income: {
        type: Object,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data(){
      return {
        invoice_types: InvoiceUtil.income_invoice_types
      }
    },
    computed: {
      //
    },
    created(){
      //
    },
    mounted(){
      //
    },
    methods: {
      closePoptip(){
        document.body.click();
      },
      getInvoiceType(type){
        return InvoiceUtil.getInvoiceType(type);
      },
      getTaxRate(rate){
        return InvoiceUtil.getTaxRate(rate);
      },
      formatPrice(price){
        return Util.formatPrice(price);
      },
      taxDataChange(income){
        const price = income.price;
        income.tax = math.eval(`${price} * ${income.tax_rate} / (1 + ${income.tax_rate})`).toFixed(2);
      },
    }
  }
</script>
